export const typographyVariants = {
    h1: {
        fontSize: '96px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: '150%',
        letterSpacing: '-1.5px',
    },

    h2: {
        fontSize: '60px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: '150%',
        letterSpacing: '-0.5px',
    },

    h3: {
        fontSize: '48px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
    },

    h4: {
        fontSize: '34px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        letterSpacing: '0.25px',
    },

    h5: {
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
    },

    h6: {
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '0.15px',
    },

    subtitle: {
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150% ',
        letterSpacing: '0.15px',
    },

    subtitle1: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150% ',
        letterSpacing: '0.15px',
    },
    subtitle1_700: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '150% ',
        letterSpacing: '0.15px',
    },

    subtitle2: {
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '0.1px',
    },

    body1: {
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        letterSpacing: '0.5px',
    },

    body2: {
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '150%',
        letterSpacing: '0.25px',
    },

    body3: {
        fontSize: '20px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: '150%',
        letterSpacing: '0.15px',
    },

    body4: {
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 300,
        lineHeight: '150%',
    },

    caption1: {
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '125%',
        letterSpacing: '0.4px',
    },

    caption2: {
        fontSize: '9px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '111.111%',
        letterSpacing: '0.3px',
        textTransform: 'uppercase',
    },

    overline: {
        fontSize: '10px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '120%',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
    },

    button: {
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '114.286%',
        letterSpacing: '1.25px',
        textTransform: 'uppercase',
    },
}